import React from 'react';
import { Typography, Button, Divider} from '@material-ui/core';
import { Elements, ElementsConsumer, CardElement } from  '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import Review from './Review';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);


const PaymentForm = ({ checkoutToken, shippingData,backStep, onCaptureCheckout, nextStep,timeout }) => {
    const handleSubmit = async(event, elements, stripe) => {
        event.preventDefault();
        if(!stripe || !elements) return;   
        const cardElement = elements.getElement(CardElement);
        const { error, paymentMethod  }= await stripe.createPaymentMethod({ type: 'card', card: cardElement, billing_details: {
            name: shippingData.firstname,email: shippingData.email
            
          } });
        
        if(error) {
            console.log(error);
        } else {
           
            const orderData ={
                line_items: checkoutToken.live.line_items,
                description: checkoutToken.live.line_items[0].permalink,
                customer: {  firstname: shippingData.firstname, 
                             email: shippingData.email
                            },
                            
                                   
                              
            
            payment: {
                gateway: 'stripe',

                stripe: {
                  
                    amount: checkoutToken.live.subtotal,
                    currency: 'usd',
                    description: 'Software development services',
                    payment_method_id: paymentMethod.id,
                   
                    confirm: true
                    
                   
                },
               
                
            },
        };
        
        onCaptureCheckout(checkoutToken.id, orderData);
        console.log(checkoutToken.id);
        console.log(orderData);
        timeout();
        nextStep();
    }
};
    return (
       <>
        <Review checkoutToken={checkoutToken}/>
        <Divider />
        <Typography variant='h6' gutterBottom style={{ margin: '20px 0'}}>Payment method</Typography>
        <Elements stripe={stripePromise} >
            <ElementsConsumer>
                {({ elements, stripe}) => (
                    <form onSubmit={(e) => handleSubmit(e, elements, stripe)}>
                        <CardElement />
                        <br/> <br/>
                        <div style={{ display:'flex', justifyContent: 'space-between'}}>
                            <Button variant='outlined' onClick={backStep}>Back</Button>
                            <Button type='submit' variant='contained' disabled={!stripe} color="primary">
                                pay { checkoutToken.live.subtotal.formatted_with_symbol }
                            </Button>
                        </div>
                    </form>

                )}
            </ElementsConsumer>
        </Elements>
       </>
    );
};

export default PaymentForm
